import { CircularProgress } from "@material-ui/core";

const LoadingButton = ({ text, loading, disabled, isZIndex }) => {
  return (
    <button
      style={{ zIndex: isZIndex ? "0" : "2000" }}
      className={`${
        !disabled ? "saveBtn1" : "saveBtn1 activv"
      } position-relative d-flex-center blur-filter-background`}
      disabled={disabled}
      type="submit"
    >
      {loading && (
        <div className="position-absolute d-flex-center blur-filter-background w-100 h-100">
          <CircularProgress size="1.5rem" className="white " />
        </div>
      )}
      {text}
    </button>
  );
};

export default LoadingButton;
